module.exports = __webpack_public_path__ + "img/nav1.59001d5d.png";